function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIslam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 50.851562 73.261719 C 35.28125 73.261719 22.589844 60.570312 22.589844 45 C 22.589844 29.339844 35.28125 16.738281 50.851562 16.738281 C 56.789062 16.738281 62.191406 18.539062 66.78125 21.601562 C 60.300781 14.308594 50.851562 9.628906 40.230469 9.628906 C 20.789062 9.628906 4.949219 25.46875 4.949219 45 C 4.949219 64.53125 20.789062 80.371094 40.230469 80.371094 C 50.851562 80.371094 60.300781 75.691406 66.78125 68.398438 C 62.191406 71.460938 56.789062 73.261719 50.851562 73.261719 Z M 85.050781 45 L 76.140625 47.878906 L 76.140625 57.328125 L 70.558594 49.679688 L 61.648438 52.648438 L 67.140625 45 L 61.648438 37.351562 L 70.558594 40.320312 L 76.140625 32.671875 L 76.140625 42.121094 Z M 85.050781 45 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIslam);
export default __webpack_public_path__ + "static/media/islam.63cc15ef083157eb51e8038da9a4db02.svg";
export { ForwardRef as ReactComponent };